module.exports = __webpack_public_path__ + "static/beam-drills-new-5df781059aa3a0626acf8343cb8d4bc1.jpg";